module.exports = __webpack_public_path__ + "static/media/177.70ce44a0.jpg";